module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(" Для добавления сотрудника отправьте этот код боту с аккаунта ТГ Вашего сотрудника:")]), _vm._v("   " + _vm._s(_vm.authcode) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "grey",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-f0010a48","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/WorkerForm.vue
// module id = 427
// module chunks = 0